/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_Nav_ChangelogInputs */

const en_marketing_nav_changelog = /** @type {(inputs: Marketing_Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Changelog`)
};

const es_marketing_nav_changelog = /** @type {(inputs: Marketing_Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cambios`)
};

const fr_marketing_nav_changelog = /** @type {(inputs: Marketing_Nav_ChangelogInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

/**
* | output |
* | --- |
* | "Changelog" |
*
* @param {Marketing_Nav_ChangelogInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const marketing_nav_changelog = /** @type {((inputs?: Marketing_Nav_ChangelogInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_Nav_ChangelogInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_marketing_nav_changelog(inputs)
	if (locale === "es") return es_marketing_nav_changelog(inputs)
	return fr_marketing_nav_changelog(inputs)
});